import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import CustomIcon from '../common/CustomIcon';
import { bindActionCreators } from 'redux';
import * as messageAlert from '../../actions/messageAlertAction';
import * as taskActions from '../../actions/taskActions';
import * as assignmentsDrawerActions from '../../actions/assignmentsDrawerActions';
import dayjs from 'dayjs';
import { I18n } from 'react-redux-i18n-lite';
import * as taskService from '../../services/domain/taskService';
import UserImage from '../common/UserImage';

import { ROLE } from '../../const';

const TO_REVIEW = 'To review';
const REVIEWED = 'Reviewed';
const PENDING = 'Pending';

class AssignmentsStudentsContentPanel extends Component {
  renderHeader() {
    const { task } = this.props;
    let dueDateTextStyle;
    let daysLeft = dayjs(task.dueDate).diff(dayjs(), 'days');
    if (daysLeft > 1) {
      dueDateTextStyle = { color: '#0caae3' };
    }
    if (daysLeft <= 1 && daysLeft >= 0) {
      dueDateTextStyle = { color: '#f05060' };
    }
    return (
      <div className="header header-assignments">
        <div className="title-assignments">
          <Link className="close">
            <CustomIcon name="office-monthly-calendar" size={24} />
          </Link>
          <span className="assignment-name">{task.name}</span>
        </div>
        <span style={dueDateTextStyle} className="assignment-due-date">
          {I18n.t('panels.assignment.dueDate')} {dayjs(task.dueDate).format('DD/MM/YYYY HH:mm')}
        </span>
      </div>
    );
  }

  renderCategoryTitle(titleStyle, groupName) {
    return <div className={`users-category-title ${titleStyle}`}>{groupName}</div>;
  }

  handleAvatarClick(student, group) {
    const { assignmentsDrawerActions, role } = this.props;
    if (role === ROLE.INSTRUCTOR || group === REVIEWED) {
      assignmentsDrawerActions.setEvaluatedStudentAndOpen(student);
    }
  }

  renderGroup(group, students, status, groupKey) {
    if (!students || students.length === 0) return;

    const avatars = [];
    let titleStyle = '';
    let groupName = '';
    let borderStyle = '';

    if (group === TO_REVIEW) {
      titleStyle = 'to-review';
      borderStyle = 'to-review';
      const groupText = I18n.t('groups.toReview');
      groupName = students.length + ' ' + groupText;
    } else if (group === PENDING) {
      groupName = students.length + ' ' + I18n.t('groups.pending');
    } else if (group === REVIEWED) {
      groupName = students.length + ' ' + I18n.t('groups.reviewed');
    } else if (group.startsWith(I18n.t('rightPanel.groups.group'))) {
      if (status === TO_REVIEW) {
        titleStyle = 'to-review';
        borderStyle = 'to-review';
        groupName = `${group} - ${I18n.t('groups.toReview')}`;
      } else if (status === PENDING) {
        groupName = `${group} - ${I18n.t('groups.pending')}`;
      } else if (status === REVIEWED) {
        groupName = `${group} - ${I18n.t('groups.reviewed')}`;
      }
    }

    students.forEach(student => {
      const enabledClass = student.enabled === 1 ? '' : 'opacity-20';

      if (group === REVIEWED || status === REVIEWED) {
        borderStyle = student.passed ? 'passed' : 'failed';
      }

      avatars.push(
        <div
          key={student._id}
          onClick={() => this.handleAvatarClick(student, group)}
          className={`user-icon pointer ${enabledClass}`}
        >
          <UserImage picture={student.picture} borderStyle={borderStyle} />
          <div className="user-name">
            {student.name} {student.surname}
          </div>
        </div>
      );
    });

    return (
      <div key={groupKey} className="users-category">
        {this.renderCategoryTitle(titleStyle, groupName)}
        <div className="users-category-icons">{avatars}</div>
      </div>
    );
  }

  render() {
    const { studentsAssigned, task } = this.props;
    const groupedStudents = task && taskService.setStudentsInGroups(studentsAssigned, task, task.resultSummary);

    return (
      <div className="assignments-panel">
        {this.renderHeader()}
        <div className="users-categories">
          {this.renderGroup(TO_REVIEW, groupedStudents && groupedStudents.toReview)}
          {this.renderGroup(REVIEWED, groupedStudents && groupedStudents.reviewed)}
          {this.renderGroup(PENDING, groupedStudents && groupedStudents.pending)}
          {groupedStudents &&
            Object.keys(groupedStudents).map(groupKey => {
              if (groupKey.startsWith('group')) {
                return this.renderGroup(
                  `${I18n.t('rightPanel.groups.group')} ${groupKey.replace('group', '')}`,
                  groupedStudents[groupKey],
                  groupedStudents[groupKey].status,
                  groupKey
                );
              }
              return null;
            })}
        </div>
      </div>
    );
  }
}

AssignmentsStudentsContentPanel.propTypes = {
  studentsAssigned: PropTypes.array,
  task: PropTypes.object,
  taskResults: PropTypes.object,
  taskActions: PropTypes.object,
  assignmentsDrawerActions: PropTypes.object,
  role: PropTypes.string
};

function mapStateToProps(state) {
  return {
    user: state.account.user,
    role:
      state.task.selectedTask &&
      state.classrooms.activeClassrooms.find(c => c.id === state.task.selectedTask.parentSection).role,
    i18n: state.i18n,
    task: state.task.selectedTask,
    studentsAssigned: state.task.studentsAssigned
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsStudentsContentPanel);
